import React from "react"

import ModalV4 from "../../../../app/ui/modal/v4/v4"
import SelectProjectType from "./select-type/select-project-type"
import Converting from "./converting/converting"
import {ProjectSystemType} from "../../../model2/project/types"

type Props = {
    params: {
        projectId   : ID // if single project convert
        projectIds  : ID[]
        callback    : func
    }
}

export default class ModalProjectConvertNew extends ModalV4 {

    constructor(props: Props) {
        super(props)

        this.state = {
            templateId      : null,
            currentScreen   : 'select-type'
        }
    }

    onTemplateTypeSelected(templateId: ID | ProjectSystemType.FOLDER | ProjectSystemType.WORKSPACE) {

        // // BULK UPDATE
        // if (this.props.params.projectIds) {
        //     this.setState({
        //         templateId      : templateId,
        //         currentScreen   : 'converting'
        //     }, ()=>{
        //
        //         const requestBulkConvert = gd.api.BulkActions.projectsConvert(this.props.params.projectIds,templateId);
        //
        //         requestBulkConvert.done(()=>{
        //             if (this.props.params.callback) this.props.params.callback({
        //                 templateId: templateId
        //             })
        //         })
        //     })
        //
        //     return
        //
        // }


        // BULK UPDATE
        if (this.props.params.projectIds) {
            this.setState({
                templateId      : templateId,
                currentScreen   : 'converting'
            }, async ()=>{
                let params: any = {
                    projectIds: this.props.params.projectIds
                }

                switch (templateId) {
                    case ProjectSystemType.FOLDER:
                        params.systemType = templateId // systemType!

                        break

                    case ProjectSystemType.WORKSPACE:
                        params.systemType = templateId // systemType!

                        if (this.props.params.projectId === gd.projectViews?.project?.id) {
                            gd.navigation.goToHome()
                        }
                        break

                    default:
                        params.templateId = templateId // templateId!
                        break
                }


                const requestBulkConvert = gd.api.BulkActions.projectsConvertV2(params);

                requestBulkConvert.done(()=>{
                    if (this.props.params.callback) this.props.params.callback({
                        templateId: templateId
                    })
                })
            })
            return
        }


        // single
        this.setState({
            templateId      : templateId,
            currentScreen   : 'converting'
        }, async ()=>{
            let params

            switch (templateId) {
                case ProjectSystemType.FOLDER:
                    params = {
                        systemType: templateId // systemType!
                    }
                    break

                case ProjectSystemType.WORKSPACE:
                    params = {
                        systemType: templateId // systemType!
                    }
                    if (this.props.params.projectId === gd.projectViews?.project?.id) {
                        gd.navigation.goToHome()
                    }
                    break

                default:
                    params = {
                        templateId: templateId
                    }
                    break
            }

            await gd.api.Project.convertV2(this.props.params.projectId,params).promise()

            if (this.props.params.callback) {
                this.props.params.callback({
                    templateId: templateId
                })
            }
        })



    }

    render() {
        return (
            <div className="v4-container placement-middle" onClick={this.stopPropagation}>
                {this.state.currentScreen === 'select-type' && <SelectProjectType parent={this} />}
                {this.state.currentScreen === 'converting' && <Converting/>}
            </div>
        )
    }
}






